document.addEventListener('DOMContentLoaded', function () {
    try {
        updateAnnouncementOffset();
        logoSlider();
        accordion();
        mediaSlider();
        productCardSlider();
        imageSlider();
        perfectProductAdd();
        bundleBuilderInit();
        removeGrouptifyBadge();
        paintFreeSliders();
        customPaintFreeSliders();
        thumbnailSlider();
        upsellBuy();
        allProductsGroupScroll();
        mobileMenuLink();
        reviewSlider();
        centerImageChange();
        stickyProduct();
        countrySelectRedirect();
        window.addEventListener('resize', updateAnnouncementOffset, { passive: true });
        document.addEventListener('shopify:section:load', countrySelectRedirect);
    } catch (error) {
        console.log(error)
    }
})

function perfectProductsSlider ( ) {

    let swiper = null;

    if(window.innerWidth < 750) { 
        swiper = new Swiper('.complementary-slide__inner', {
            slidesPerView : 1.2,
            spaceBetween : 10,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        })
    }
}

function logoSlider() {
    const logoSliders = document.querySelectorAll('.logo-slider__container');
 
    logoSliders.forEach(logoSlider => {
 
        const id = logoSlider.id;
 
        const quotes = logoSlider.querySelector('.logo-slider__quote--wrapper')
 
        const logoSpeed = (parseFloat(logoSlider.dataset.logoSpeed) || 5) * 1000;
        const textSpeed = (parseFloat(logoSlider.dataset.textSpeed) || 7) * 1000;
 
        const swiper = new Swiper(`#${id} .logo-slider__inner`, {
            slidesPerView : 'auto',
            spaceBetween : 0,
            loop : true,
            centeredSlides : true,
            loopAdditionalSlides : 30,    
            slideToClickedSlide: true,
            breakpoints: {
                990 : {
                    spaceBetween : 0,
                    loop : false,
                }
            },
            autoplay: {
                delay: logoSpeed,
                disableOnInteraction: false,
            },
        })
 
        const quoteItems = quotes.querySelectorAll('.logo-item__quote');
 
        if (quoteItems.length > 1) {
            setInterval(() => {
                const current = quotes.querySelector('.logo-item__quote.active');
                const next = quoteItems[(Array.from(quoteItems).indexOf(current) + 1) % quoteItems.length];
 
                current?.classList.remove('active');
                next.classList.add('active');
            }, textSpeed);
        }
 
        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
            swiper.params.autoplay.delay = logoSpeed;
            swiper.update()
        }
 
        swiper.on('reachEnd', () => {
            setTimeout(() => {
              swiper.slideTo(0);
            }, 2500);
        });
    })
}

function accordion() {
    document.querySelectorAll('.faqs-group__inner').forEach(group => {
        group.querySelectorAll('.faqs-group__item').forEach(accordion => {
            accordion.querySelector('.accordion-heading').addEventListener('click', function () {
                let body = accordion.querySelector('.accordion-body');

                accordion.classList.toggle('active');

                if (accordion.classList.contains('active')) {
                    body.style.maxHeight = body.scrollHeight + 'px';
                } else {
                    body.style.maxHeight = 0;
                }

            })
        })
    })
}

function mediaSlider () {
    let sliderComponents = document.querySelectorAll('.media-slider__container');
    if (!sliderComponents) return;
    
    sliderComponents.forEach(comp => {

        let sliderId = comp.id;

        const swiper = new Swiper(`#${sliderId} .media-slider__inner`, {
            slidesPerView: 1.5,
            spaceBetween: 10,
            loop : false,  
            slideToClickedSlide: true,
            centeredSlides : true,
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                990 : {
                    slidesPerView: 3,
                    spaceBetween : 10,
                    pagination: false
                }
            }
        })

        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
            // const video = swiper.slides[Math.ceil(swiper.slides.length / 2 - 1)];

            swiper.slides.forEach(ele => {
                console.log(ele)
                //ele.querySelector('video').play()
            })
        }

    })
}

function imageSlider () {
    let sliderComponents = document.querySelectorAll('.image-slider__container');

    
    sliderComponents.forEach(comp => {

        let sliderId = comp.id;

        const swiper = new Swiper(`#${sliderId} .image-slider__inner`, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop : false,  
            slideToClickedSlide: true,
            centeredSlides : true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                990 : {
                    slidesPerView: 3,
                    spaceBetween : 10,
                    pagination: false
                }
            }
        })

        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
        }
    })
}

function productCardSlider () {
    let cards = document.querySelectorAll('.collection-product__card');

    cards.forEach(card => {
        let id = card.id;

        if(id) {
            new Swiper(`#${id} .product-card__media-slider`, {
                slidesPerView : 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            })
        }
    })
}

function paintFreeSliders() {
   let slides = document.querySelectorAll('.paint-free__container');

    slides.forEach(slide => {
        const id = slide.id;

        const medias = document.querySelector('.paint-free__media')
        const descriptions = document.querySelector('.paint-free__description-count')
        
        const swiper = new Swiper(`#${id} .paint-free__description`, {
            slidesPerView : 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        swiper.on('slideChange', function () {
            const currentIndex = swiper.activeIndex;

            descriptions.querySelector('.active')?.classList.remove('active');
            descriptions.querySelector(`[data-desc-index="${currentIndex + 1}"]`)?.classList.add('active');

            medias.querySelector('.active')?.classList.remove('active');
            medias.querySelector(`[data-point-index="${currentIndex + 1}"]`)?.classList.add('active');
        });

        medias.querySelectorAll('.media-point__position')?.forEach(media => {
            media.addEventListener('click' , function (e) {
                swiper.slideTo(media.getAttribute('data-point-index') - 1)
            })
        })

        descriptions.querySelectorAll('.description-count__number')?.forEach(media => {
            media.addEventListener('click' , function (e) {
                swiper.slideTo(media.getAttribute('data-desc-index') - 1)
            })
        })
    });
}

function perfectProductAdd() {
    const buy_buttons = document.querySelectorAll('.perfect-product-buy_button');
    buy_buttons.forEach(buy_button => {
        buy_button.addEventListener('click', function (e) {
            
            const product_id = buy_button.closest('.item__info').querySelector('#variant_id').value;
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            const data = {
                'id' : product_id,
                'quantity' : 1,
                "sections" : cart.getSectionsToRender().map((section) => section.id),
                "sections_url" : window.location.pathname
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then (res => {
                return res.json()
            }).then (resJson => {
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                setTimeout(() => {
                    cart.renderContents(resJson);
                }, 100);
            })
        })
    })

    document.querySelectorAll('.item__info-variants select').forEach(select => {

        const item = select.closest('.perfect-product__item');

        const json = JSON.parse(item.querySelector('[data-upsell-json]').textContent);

        const price = item.querySelector('.item__info-price');
        const discount = parseFloat(price.dataset.discountPercent);

        select.addEventListener('change', function () {
            const id = select.value;

            const variant = json.variants.find(v => v.id == id);

            if (discount) {
                price.innerHTML = `<div class="price">${getMoney((variant.price / 100) * discount)}</div><div class="compare">${getMoney(variant.price / 100)}</div>`
            } else {
                price.innerHTML = `<div class="price">${getMoney(variant.price / 100)}</div>`
            }
        })
    })
}

function getMoney(amount) {
    return new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active,
    }).format(amount);
}

function thumbnailSlider() {
    const thumbnailWrapper = document.querySelector('.thumbnail-slider');

    if (thumbnailWrapper) {
        let swiper = new Swiper('.thumbnail-slider', {
            slidesPerView : 4.5,
            spaceBetween : 10,
            breakpoints: {
                990 : {
                    slidesPerView: 5.5,
                }
            }
        })
    }
}

function upsellBuy() { 
    const upsellProducts = document.querySelectorAll('.upsell-product--item');

    if (!customElements.get('upsell-cart-item')) {
        customElements.define('upsell-cart-item', 
            class upsellCartItem extends HTMLElement {
                constructor (){
                    super()

                    const buyButton = this.querySelector('.product--buy');
            
                    buyButton.addEventListener('click', function (e) {
                        const cart = document.querySelector('cart-drawer');
                        const data = {
                            'id' : buyButton.dataset.productId,
                            'quantity' : 1,
                            "sections" : cart.getSectionsToRender().map((section) => section.id),
                            "sections_url" : window.location.pathname
                        };
            
                        fetch('/cart/add.js', {
                            method : "POST",
                            headers : {
                                'Content-Type': 'application/json'
                            },
                            body : JSON.stringify(data)
                        }).then(res => {
                            return res.json();
                        }).then(resJson => {
                            cart.getSectionsToRender().forEach((section) => {
                            const sectionElement = section.selector
                                ? document.querySelector(section.selector)
                                : document.getElementById(section.id);
                        
                            if (!sectionElement) return;
                                sectionElement.innerHTML = cart.getSectionInnerHTML(resJson.sections[section.id], section.selector);
                            });

                            cart.querySelector('#CartDrawer-Overlay').addEventListener('click', cart.close.bind(cart));

                        })
                    })
                }
            }
        )
    }
}

function allProductsGroupScroll () {
    const labels = document.querySelectorAll('.products_label--item');

    labels.forEach(label => {
        label.addEventListener('click', function (e) {
            let wrapper = document.querySelector(`[data-block-group-id="${label.id}"]`);
            smoothScroll( wrapper.offsetTop , 500);
        })
    })
}

function smoothScroll(target, duration) {
    const start = window.scrollY;
    const distance = target - start;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Make sure progress does not exceed 1
        const ease = easeInOutQuad(progress); // You could use any easing function here
        window.scrollTo(0, start + (distance * ease));

        if (timeElapsed < duration) {
            requestAnimationFrame(animation); // Keep animating
        }
    }

    requestAnimationFrame(animation);
}

function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function mobileMenuLink() {
    const menuItems = document.querySelectorAll('.menu-drawer-accordion-menu--item');

    const toggleItem = (item) => {
        const toggle = item.querySelector('.accordion-menu__toggle');
        const hasSubmenu = !!item.querySelector('.accordion-menu__body');

        if (!hasSubmenu) return false;

        item.parentElement?.querySelectorAll('.menu-drawer-accordion-menu--item.open')?.forEach(sib => {
            if (sib !== item) sib.classList.remove('open');
        });

        if (item.classList.contains('open')) {
            item.classList.remove('open');
        } else {
            item.classList.add('open');
        }
        return true;
    };

    menuItems.forEach(item => {
        const toggle = item.querySelector('.accordion-menu__toggle');
        if (!toggle) return;

        toggle.addEventListener('click', function(e) {
            const handled = toggleItem(item);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        item.addEventListener('click', function(e) {
            if (e.target.closest('a')) return;
            const handled = toggleItem(item);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    });
}

function reviewSlider() {
    const reviewSliders = document.querySelectorAll('.reviews-slider__inner');

    reviewSliders.forEach(slider => {
        const sliderId = slider.id;

        var thumbs = new Swiper(`#${sliderId} .reviews-thumbnail__slider`, {
            slidesPerView: 4,
            spaceBetween: 10,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        
        var slider = new Swiper(`#${sliderId} .reviews-main__slider`, {
            slidesPerView: 1,
            spaceBetween : 30,
            centeredSlides: true,
            loop: true,
            loopedSlides: 6,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: thumbs
            },
            breakpoints: {
                990 : {
                    slidesPerView: 1.5,
                    spaceBetween : 15
                },
                1200 : {
                    slidesPerView: 2,
                    spaceBetween : 15
                }
            }
        });
    })
}

function centerImageChange () {
    const centerImages = document.querySelectorAll('.center-image__container');

    centerImages.forEach(centerImage => {
        
        const mainImage = centerImage.querySelector('.center-image__media')
        
        centerImage.querySelectorAll('.center-image__card').forEach(card => {
            card.addEventListener('click', function(e) {
                const cardId = this.dataset.cardId;
                centerImage.querySelector('.center-image__card.active')?.classList.remove('active');

                card.classList.add('active');

                mainImage.querySelector(`.main-image.active`)?.classList.remove('active');
                mainImage.querySelector(`[data-card-id="${cardId}"]`)?.classList.add('active');
            })
        })

    })
}

function stickyProduct() {
    const stickyProducts = document.querySelectorAll('.sticky-product__container');
    const mainProduct = document.querySelector('.product');

    stickyProducts.forEach(stickyProduct => {

        if (stickyProduct) {
            stickyProduct.querySelector('.sticky-atc').addEventListener('click', function (e) {
                mainProduct.querySelector('.product-form__submit').click();
            })
        }

        const updateVisibility = () => {
            if (!stickyProduct || !mainProduct) return;
            const atcButton = mainProduct.querySelector('.product-form__submit');
            if (!atcButton) return;

            const rect = atcButton.getBoundingClientRect();
            // Show only after we've scrolled past the main ATC (its top is above viewport)
            const scrolledPastMainATC = rect.top <= 0;

            if (scrolledPastMainATC) {
                stickyProduct.classList.remove('hide');
            } else {
                stickyProduct.classList.add('hide');
            }
        };

        ['scroll','resize','orientationchange'].forEach(evt => window.addEventListener(evt, updateVisibility, { passive: true }));
        // initial check
        updateVisibility();
    })
}

function updateAnnouncementOffset() {
    const bar = document.querySelector('.announcement-bar-section');
    const height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
}

function countrySelectRedirect() {
    const selects = document.querySelectorAll('.supporting-menu__country .country-select');

    selects.forEach(select => {
        // Remove prior listener by cloning (prevents stacking on editor reloads)
        const newSelect = select.cloneNode(true);
        if (select.parentNode) select.parentNode.replaceChild(newSelect, select);

        newSelect.addEventListener('change', function () {
            const url = (this.value || '').trim();
            if (url) {
                window.location.assign(url);
            }
        })
    })
}

window.addEventListener('DOMContentLoaded', function () {
    
    const centerImages = document.querySelectorAll('.center-image__container');

    centerImages.forEach(centerImage => {
        let cards = centerImage.querySelectorAll('.center-image__card');
        let currentIndex = 0;
        const totalHighlights = cards.length;
        let autoCycle;

        function showHighlight(index) {
            cards.forEach((highlight, i) => {
                if (index == i) {
                    highlight.click()
                }
            });
        }

        function nextHighlight() {
            currentIndex = (currentIndex + 1) % totalHighlights;
            showHighlight(currentIndex);
        }

        function startAutoCycle() {
            autoCycle = setInterval(() => {
                if (currentIndex < totalHighlights - 1) {
                    nextHighlight();
                } else {
                    showHighlight(0)
                    clearInterval(autoCycle);
                }
            }, 5000);
        }

        startAutoCycle()
    })

})

function customPaintFreeSliders() {
    let slides = document.querySelectorAll('.custom-paint-free__container');
 
     slides.forEach(slide => {
         const id = slide.id;

         const medias = slide.querySelector('.custom-paint-free__media')
         const descriptions = slide.querySelector('.custom-paint-free__description-count')
         
         const swiper = new Swiper(`#${id} .custom-paint-free__description`, {
             slidesPerView : 1,
             pagination: {
                 el: ".swiper-pagination",
                 clickable: true,
             },
         });

         swiper.on('slideChange', function () {
             const currentIndex = swiper.activeIndex;

             descriptions.querySelector('.active')?.classList.remove('active');
             descriptions.querySelector(`[data-desc-index="${currentIndex + 1}"]`)?.classList.add('active');

             medias.querySelector('.active')?.classList.remove('active');
             medias.querySelector(`[data-point-index="${currentIndex + 1}"]`)?.classList.add('active');
             
             // Switch media slides
             medias.querySelectorAll('.custom-paint-free__media-slide').forEach(slide => {
                 slide.classList.remove('active');
             });
             medias.querySelector(`[data-media-index="${currentIndex + 1}"]`)?.classList.add('active');
         });

         medias.querySelectorAll('.media-point__position')?.forEach(media => {
             media.addEventListener('click' , function (e) {
                 swiper.slideTo(media.getAttribute('data-point-index') - 1)
             })
         })

         descriptions.querySelectorAll('.description-count__number')?.forEach(media => {
             media.addEventListener('click' , function (e) {
                 swiper.slideTo(media.getAttribute('data-desc-index') - 1)
             })
         })
     });
}

/* Hide compare at price if it's equal to the product price */
document.addEventListener("DOMContentLoaded", () => {
  const normalizePrice = (text) => {
    const cleaned = (text || "")
      .replace(/\s+/g, " ")
      .replace(/[^\d.,]/g, "")
      .trim();

    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");

    let normalized = cleaned;
    if (lastComma > lastDot) normalized = cleaned.replace(/\./g, "").replace(",", ".");
    else normalized = cleaned.replace(/,/g, "");

    const n = Number(normalized);
    return Number.isFinite(n) ? n : NaN;
  };

  const observed = new WeakSet();
  const rafQueued = new WeakSet();

  const hide = (el) => {
    if (!el) return;
    el.style.setProperty("display", "none", "important");
  };

  const unhide = (el) => {
    if (!el) return;
    el.style.removeProperty("display");
    if (el.getAttribute("style") === "") el.removeAttribute("style");
  };

  const schedule = (root, fn) => {
    if (!root || rafQueued.has(root)) return;
    rafQueued.add(root);
    requestAnimationFrame(() => {
      rafQueued.delete(root);
      fn();
    });
  };

  function fixPriceContainer(root) {
    root.querySelectorAll(".price__container").forEach((container) => {
      const saleWrap = container.querySelector(".price__sale");
      if (!saleWrap) return;

      const saleEl = saleWrap.querySelector(".price-item--sale");
      if (!saleEl) return;

      const sale = normalizePrice(saleEl.textContent);
      if (!Number.isFinite(sale)) return;

      saleWrap.querySelectorAll(".price-item--regular").forEach((regularEl) => {
        const regular = normalizePrice(regularEl.textContent);
        if (!Number.isFinite(regular)) return;

        if (sale === regular) hide(regularEl);
        else unhide(regularEl);
      });
    });
  }

  function fixPack(root) {
    root.querySelectorAll(".pack--price").forEach((container) => {
      const minEl = container.querySelector(".pack--min-price");
      const maxEl = container.querySelector(".pack--max-price");
      if (!minEl || !maxEl) return;

      const min = normalizePrice(minEl.textContent);
      const max = normalizePrice(maxEl.textContent);

      if (Number.isFinite(min) && Number.isFinite(max) && min === max) hide(maxEl);
      else unhide(maxEl);
    });
  }

  function fixProductPrice(root) {
    root.querySelectorAll(".product__price").forEach((container) => {
      const saleEl = container.querySelector(".price-item--sale");
      const regularEl = container.querySelector(".price-item--regular");
      const badgeEl = container.querySelector(".price__badge-sale");
      if (!saleEl || !regularEl) return;

      const sale = normalizePrice(saleEl.textContent);
      const regular = normalizePrice(regularEl.textContent);

      if (Number.isFinite(sale) && Number.isFinite(regular) && sale === regular) {
        hide(regularEl);
        hide(badgeEl);
      } else {
        unhide(regularEl);
        unhide(badgeEl);
      }
    });
  }

  function fixItemCompare(root) {
    root.querySelectorAll(".perfect-product__item .item__info-price").forEach((box) => {
      const priceEl = box.querySelector(".price");
      const compareEl = box.querySelector(".compare");
      if (!priceEl || !compareEl) return;

      const price = normalizePrice(priceEl.textContent);
      const compare = normalizePrice(compareEl.textContent);

      if (Number.isFinite(price) && Number.isFinite(compare) && price === compare) {
        compareEl.remove();
      }
    });
  }

  function fixCardBadges(root) {
    root.querySelectorAll(".card__badge .badge").forEach((badge) => {
      const value = parseFloat(badge.textContent.replace(/[^\d.]/g, ""));
      if (Number.isFinite(value) && value === 0) {
        badge.style.setProperty("display", "none", "important");
      } else {
        badge.style.removeProperty("display");
        if (badge.getAttribute("style") === "") badge.removeAttribute("style");
      }
    });
  }

  function fixStickyAtc(root) {
    root.querySelectorAll(".sticky-atc, .sticky-product__price").forEach((wrap) => {
        const priceEl = wrap.querySelector(".price:not(.compare_price)");
        const compareEl = wrap.querySelector(".compare_price");
        if (!priceEl || !compareEl) return;

        const price = normalizePrice(priceEl.textContent);
        const compare = normalizePrice(compareEl.textContent);

        if (Number.isFinite(price) && Number.isFinite(compare) && price === compare) {
        hide(compareEl);
        } else {
        unhide(compareEl);
        }
    });
    }

  function fixUpsellCartPrices(root) {
    root.querySelectorAll(".upsell-product--item__price").forEach((container) => {
      const priceEl = container.querySelector(".item--price");
      const compareEl = container.querySelector(".item--compare-price");
      if (!priceEl || !compareEl) return;

      const price = normalizePrice(priceEl.textContent);
      const compare = normalizePrice(compareEl.textContent);

      if (Number.isFinite(price) && Number.isFinite(compare) && price === compare) hide(compareEl);
      else unhide(compareEl);
    });
  }

  function runAll(root) {
    fixItemCompare(root);
    fixPack(root);
    fixPriceContainer(root);
    fixProductPrice(root);
    fixCardBadges(root);
    fixStickyAtc(root);
    fixUpsellCartPrices(root);
  }

  function observe(el, runner) {
    if (!el || observed.has(el)) return;
    observed.add(el);

    const mo = new MutationObserver(() => {
      schedule(el, () => runner(el));
    });

    mo.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    runner(el);
  }

  function observeTargets() {
    document.querySelectorAll(".swiper, .swiper-container, .swiper-wrapper").forEach((sw) => observe(sw, runAll));
    document.querySelectorAll("product-recommendations").forEach((pr) => observe(pr, runAll));
    document.querySelectorAll(".product-form__packs--wrapper").forEach((wrap) => observe(wrap, runAll));
    document.querySelectorAll(".product__price").forEach((pp) => observe(pp, runAll));
    document.querySelectorAll(".sticky-atc").forEach((btn) => observe(btn, runAll));

    document.querySelectorAll("upsell-cart-item, .cart-drawer, cart-drawer, #CartDrawer").forEach((cd) => {
      observe(cd, runAll);
    });
  }

  const rerunProductArea = () => {
    const roots = new Set();

    document.querySelectorAll(".product-form__packs--wrapper").forEach((el) => roots.add(el));
    document.querySelectorAll(".product__price").forEach((el) => roots.add(el));
    document.querySelectorAll("product-info, product-form").forEach((el) => roots.add(el));

    if (roots.size === 0) roots.add(document);

    roots.forEach((root) => {
      schedule(root, () => runAll(root));
      requestAnimationFrame(() => schedule(root, () => runAll(root)));
    });
  };

  observeTargets();
  runAll(document);

  document.addEventListener("change", (e) => {
    if (
      e.target.closest(".product-form__packs--wrapper") ||
      e.target.closest("fieldset.product-form__input") ||
      e.target.closest("variant-selects") ||
      e.target.closest("product-form") ||
      e.target.closest("product-info")
    ) {
      rerunProductArea();
    }
    fixUpsellCartPrices(document);
  });

  document.addEventListener("variant:change", () => {
    rerunProductArea();
    fixUpsellCartPrices(document);
  });

  let tries = 0;
  const timer = setInterval(() => {
    observeTargets();
    tries += 1;
    if (++tries >= 5) clearInterval(timer);
  }, 250);
});

/* Google events */
(function () {
  const DEBUG = false;
  const fired = new Set();
  const queue = [];
  let flushTimer = null;

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, arguments); } catch (_) {}
  }

  function flush() {
    if (typeof window.gtag !== 'function') return;
    while (queue.length) {
      const ev = queue.shift();
      window.gtag('event', ev.name, ev.params);
      log('[GA4]', ev.name, ev.params.event_category, ev.params.event_label);
    }
  }

  function send(category, label, eventName) {
    const ev = {
      name: eventName,
      params: { event_category: category, event_label: label }
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', ev.name, ev.params);
      log('[GA4]', ev.name, category, label);
      return;
    }

    queue.push(ev);
    if (!flushTimer) {
      flushTimer = setInterval(function () {
        flush();
        if (typeof window.gtag === 'function') {
          clearInterval(flushTimer);
          flushTimer = null;
        }
      }, 250);
    }
  }

  function once(key, fn) {
    if (fired.has(key)) return;
    fired.add(key);
    fn();
  }

  function whenExists(selector, cb, tries) {
    let n = 0;
    const max = typeof tries === 'number' ? tries : 80;
    const t = setInterval(function () {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(t);
        cb(el);
      } else if (++n >= max) {
        clearInterval(t);
      }
    }, 250);
  }

  function reachTop(selector, key, category, label, bottom) {
    whenExists(selector, function (el) {
      function handler() {
        if (fired.has(key)) return;
        const rect = el.getBoundingClientRect();
        if ((!bottom && rect.top <= 0) || (bottom && rect.bottom <= 0)) {
          once(key, function () { send(category, label, 'Scroll'); });
          window.removeEventListener('scroll', handler);
          window.removeEventListener('resize', handler);
        }
      }
      window.addEventListener('scroll', handler, { passive: true });
      window.addEventListener('resize', handler);
      handler();
    });
  }

  function bottomReachTop(selector, key, category, label) {
    whenExists(selector, function (el) {
      function handler() {
        if (fired.has(key)) return;
        const rect = el.getBoundingClientRect();
        if (rect.bottom <= 0) {
          once(key, function () { send(category, label, 'Scroll'); });
          window.removeEventListener('scroll', handler);
          window.removeEventListener('resize', handler);
        }
      }
      window.addEventListener('scroll', handler, { passive: true });
      window.addEventListener('resize', handler);
      handler();
    });
  }

  document.addEventListener('click', function (e) {
    const summary = e.target.closest('.template-product .product__accordion summary');
    if (!summary) return;

    const wrap = summary.closest('.template-product .product__accordion');
    if (!wrap) return;

    const accs = Array.prototype.slice.call(
      document.querySelectorAll('.template-product .product__accordion')
    );

    const idx = accs.indexOf(wrap) + 1;

    if (idx === 1) send('Element', 'Features', 'Click - Element');
    else if (idx === 2) send('Element', 'Specifications', 'Click - Element');
    else if (idx === 3) send('Element', 'Material & Care', 'Click - Element');
    else if (idx === 4) send('Element', 'Shipping & Returns', 'Click - Element');
  }, true);

  const clickMap = [
    ['.template-index .header-banner__button a','Call To Action','Hero-Ergo'],
    ['.template-index .center-image__cards-group > div:first-child','Element','Neck'],
    ['.template-index .center-image__cards-group > div:nth-child(2)','Element','Face'],
    ['.template-index .center-image__cards-group > div:nth-child(3)','Element','Shoulder'],
    ['.template-index .center-image__cards-group > div:nth-child(4)','Element','Sleep'],
    ['.template-index .center-image__bottom .btn','Call To Action','Deeper Sleep-Ergo'],
    ['.template-index .block_image-text__container:first-child .block-image-text__text-button a','Call To Action','Upgrade-Ergo'],
    ['.template-index .block_image-text__container:nth-child(2) .block-image-text__text-button a','Call To Action','Upgrade-OG'],
    ['.template-index .video-with-text__text-button a','Call To Action','Relaxed Morning-Ergo'],
    ['.template-index .custom-content__bottom a','Call To Action','Spine'],
    ['.template-index .position__button a','Call To Action','Sleeping Positions-Ergo'],
    ['.media-slider__container .swiper-button-next','Element','UGC Right Arrow'],
    ['.media-slider__container .swiper-button-prev','Element','UGC Left Arrow'],
    ['.template-index .section-pillows__accordions > div:first-child','Element','Neck Card'],
    ['.template-index .section-pillows__accordions > div:nth-child(2)','Element','Massage Card'],
    ['.template-index .section-pillows__accordions > div:nth-child(3)','Element','Head Card'],
    ['.template-index .section-pillows__accordions > div:nth-child(4)','Element','Shoulder Card'],
    ['.template-index .section-pillows__accordions > div:nth-child(5)','Element','Arm Card'],
    ['.template-index .section-pillows__media > div:nth-child(2)','Element','Neck Button'],
    ['.template-index .section-pillows__media > div:nth-child(3)','Element','Massage Button'],
    ['.template-index .section-pillows__media > div:nth-child(4)','Element','Head Button'],
    ['.template-index .section-pillows__media > div:nth-child(5)','Element','Shoulder Button'],
    ['.template-index .section-pillows__media > div:nth-child(6)','Element','Arm Button'],
    ['.template-index .section-pillows__text a.btn','Call To Action','Sleep Support - Ergo'],
    ['.template-index .comparison-list__item:nth-child(2) .item--info__link a','Call To Action','Comparison - Ergo'],
    ['.template-index .comparison-list__item:nth-child(3) .item--info__link a','Call To Action','Comparison - OG'],
    ['.template-index .section-faqs-group .faqs-group__item:nth-child(1)','Element','FAQ 1'],
    ['.template-index .section-faqs-group .faqs-group__item:nth-child(2)','Element','FAQ 2'],
    ['.template-index .section-faqs-group .faqs-group__item:nth-child(3)','Element','FAQ 3'],
    ['.template-index .section-faqs-group .faqs-group__item:nth-child(4)','Element','FAQ 4'],
    ['.template-index .section-faqs-group .faqs-group__item:nth-child(5)','Element','FAQ 5'],
    ['.template-index .section-faqs-group .faqs-group__item:nth-child(6)','Element','FAQ 6'],
    ['.template-index .section-faqs-group .faqs-group__item:nth-child(7)','Element','FAQ 7'],
    ['.footer .newsletter-form__submit','Call To Action','Email Subscribe'],
    ['.announcement-bar__message a','Element','Announcement Bar'],
    ['.header__icon--cart','Element','Cart'],
    ['.header__icons .btn','Call To Action','Nav - category'],
    ['.product-form__pack.single_pack','Element','1x Card'],
    ['.product-form__pack.double_pack','Element','2x Card'],
    ['.product-form__pack.family_pack','Element','4x Card'],
    ['.product-form__submit','Call To Action','PP Main '],
    ['.complementary-products__container .perfect-product__item:first-child .perfect-product-buy_button','Call To Action','PP Upsell 1'],
    ['.complementary-products__container .perfect-product__item:nth-child(2) .perfect-product-buy_button','Call To Action','PP Upsell 2'],
    ['.complementary-products__container .perfect-product__item:nth-child(3) .perfect-product-buy_button','Call To Action','PP Upsell 3'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(1)','Element','PP FAQ 1'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(2)','Element','PP FAQ 2'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(3)','Element','PP FAQ 3'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(4)','Element','PP FAQ 4'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(5)','Element','PP FAQ 5'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(6)','Element','PP FAQ 6'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(7)','Element','PP FAQ 7'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(8)','Element','PP FAQ 8'],
    ['.template-product .section-faqs-group .faqs-group__item:nth-child(9)','Element','PP FAQ 9'],
    ['.drawer__close','Element','Cart X button'],
    ['.cart-quantity > button[name="minus"]','Element','Minus Quantity'],
    ['.cart-quantity > button[name="plus"]','Element','Plus Quantity'],
    ['.cart-item .cart-remove-button','Call To Action','Remove'],
    ['.cart__checkout-button','Call To Action','Secure Checkout'],
    ['.paint-free__description-count .description-count__number:first-child','Element','Better Morning 1'],
    ['.paint-free__description-count .description-count__number:nth-child(2)','Element','Better Morning 2'],
    ['.paint-free__description-count .description-count__number:nth-child(3)','Element','Better Morning 3'],
    ['.paint-free__description-count .description-count__number:nth-child(4)','Element','Better Morning 4'],
    ['.paint-free__description-count .description-count__number:nth-child(5)','Element','Better Morning 5'],
    ['.paint-free__media .media-point__position:nth-child(2)','Element','Morning Button 1'],
    ['.paint-free__media .media-point__position:nth-child(3)','Element','Morning Button 2'],
    ['.paint-free__media .media-point__position:nth-child(4)','Element','Morning Button 3'],
    ['.paint-free__media .media-point__position:nth-child(5)','Element','Morning Button 4'],
    ['.paint-free__media .media-point__position:nth-child(6)','Element','Morning Button 5'],

    /* Ergo v2 template events */
    ['.template-ergo-pillow-prodpv-1 .product__media-item:first-child','Element','1st pic'],
    ['.template-ergo-pillow-prodpv-1 .product__media-item:nth-child(2)','Element','2nd pic'],
    ['.template-ergo-pillow-prodpv-1 .product__media-item:nth-child(3)','Element','3rd pic'],
    ['.template-ergo-pillow-prodpv-1 .product__media-item:nth-child(4)','Element','4th pic'],
    ['.template-ergo-pillow-prodpv-1 .product__media-item:nth-child(5)','Element','5th pic'],
    ['.template-ergo-pillow-prodpv-1 .product__media-item:nth-child(6)','Element','6th pic'],
    ['.template-ergo-pillow-prodpv-1 .product__media-item:nth-child(7)','Element','7th pic'],

    ['.template-ergo-pillow-prodpv-1 .derila-rating__cta .button','Call To Action','Transform your Sleep'],
    ['.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_right_text_with_image_d74JWH .button','Call To Action','Tomorrow'],
    ['.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_left_text_with_image_hCcDMm .button','Call To Action','cool night'],
    ['.template-ergo-pillow-prodpv-1 .derila-image-text .button','Call To Action','transform sleep'],
    ['.template-ergo-pillow-prodpv-1 .jdgm-paginate__load-more','Call To Action','load reviews'],
    ['.template-ergo-pillow-prodpv-1 .related-products .grid__item:first-child','Element','You may also like 1'],
    ['.template-ergo-pillow-prodpv-1 .related-products .grid__item:nth-child(2)','Element','You may also like 2'],
    ['.template-ergo-pillow-prodpv-1 .related-products .grid__item:nth-child(3)','Element','You may also like 3'],
    ['.template-ergo-pillow-prodpv-1 .related-products .grid__item:nth-child(4)','Element','You may also like 4'],
    ['.template-ergo-pillow-prodpv-1 .sticky-atc','Call To Action','Sticky']
  ];

  let lastUserTs = 0;
  let lastUserPath = null;

  function markUser(e) {
    if (!e.isTrusted) return;
    lastUserTs = Date.now();
    lastUserPath = (e.composedPath && e.composedPath()) || null;
  }

  window.addEventListener('pointerdown', markUser, true);
  window.addEventListener('touchstart', markUser, true);
  window.addEventListener('mousedown', markUser, true);

  document.addEventListener('click', function (e) {
    const within = Date.now() - lastUserTs < 900;
    const inPath = lastUserPath && lastUserPath.indexOf(e.target) !== -1;
    if (!(e.isTrusted || (within && inPath))) return;

    for (let i = 0; i < clickMap.length; i++) {
      const m = clickMap[i];
      if (e.target.closest(m[0])) {
        send(
          m[1],
          m[2],
          m[1] === 'Call To Action' ? 'Click - CTA' : 'Click - Element'
        );
        break;
      }
    }
  }, true);

  reachTop('.template-index .hero-banner__container','sec_nav','Section','Navigation');
  reachTop('.template-index .center-image__container','sec_mentioned','Section','Mentioned');
  bottomReachTop('.template-index .center-image__container','sec_deeper','Section','Deeper Sleep');
  reachTop('.template-index .media-with-text','sec_upgrade','Section','Upgrade');
  bottomReachTop('.template-index .media-with-text','sec_relaxed','Section','Relaxed Morning');
  reachTop('.template-index .section-position','sec_spine','Section','Spine');
  reachTop('.template-index .media-slider__container','sec_sleep_pos','Section','Sleeping Positions');
  reachTop('.template-index .section-comparison-list','sec_sleep_support','Section','Sleep Support');
  reachTop('.template-index .section-reviews','sec_comparison','Section','Comparison');
  reachTop('.template-index .image-slider__container','sec_faq','Section','FAQ');
  reachTop('.template-index .section-faqs-group','sec_ugc_reviews','Section','UGC-Reviews');
  reachTop('.template-index .footer','sec_footer','Section','Derila Family');

  reachTop('.product__title h1','sec_product_name','Section','Product Name');
  reachTop('.template-product .media-slider__container','sec_product_view','Section','Product View');
  reachTop('.template-product .multi-media__container','sec_pp_ugc','Section','PP UGC');
  reachTop('.paint-free__container','sec_night_comfort','Section','Night Comfort');
  reachTop('.template-product .section-comparison-list','sec_better_mornings','Section','Better Mornings');
  reachTop('.template-product .section-faqs-group','sec_vs_table','Section','VS Table');
  reachTop('.template-product .section-faqs-group','sec_faq_end','Section','FAQ', true);

  /* Ergo v2 template events */
  reachTop('.template-ergo-pillow-prodpv-1 .product-form','sec_ergo_v2_cta','Section','CTA');
  reachTop('.template-ergo-pillow-prodpv-1 .derila-rating','sec_ergo_v2_product_info','Section','Product Info');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_video_text_wcWpci','sec_ergo_v2_transform_sleep','Section','Transform your sleep');
  reachTop('.template-ergo-pillow-prodpv-1 .derila-columns','sec_ergo_v2_pain','Section','Pillow causing pain');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_left_text_with_image_M8yexk','sec_ergo_v2_while_you_sleep','Section','while you sleep');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_right_text_with_image_d74JWH','sec_ergo_v2_breathe_sleep','Section','breathe sleep');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_left_text_with_image_Wk7ifH','sec_ergo_v2_tomorrow','Section','tomorrow');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_column_features_K4BpCE','sec_ergo_v2_neck_relax','Section','neck relax');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_left_text_with_image_hCcDMm','sec_ergo_v2_layer','Section','layer');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_right_text_with_image_fFjkr9','sec_ergo_v2_cool_night','Section','cool night');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_column_features_fFezHx','sec_ergo_v2_anti_allergen','Section','anti-allergen');
  reachTop('.template-ergo-pillow-prodpv-1 #shopify-section-template--28671982960983__derila_video_text_46ijhe','sec_ergo_v2_any_position','Section','any position');
  reachTop('.template-ergo-pillow-prodpv-1 .derila-image-text','sec_ergo_v2_cloud_softness','Section','cloud-like softness');
  reachTop('.template-ergo-pillow-prodpv-1 .section-faqs-group','sec_ergo_v2_transform_sleep_2','Section','transform sleep');
  reachTop('.template-ergo-pillow-prodpv-1 #judgeme_product_reviews','sec_ergo_v2_faq','Section','FAQ');
  reachTop('.template-ergo-pillow-prodpv-1 .related-products','sec_ergo_v2_reviews','Section','Reviews');

  log('[GA4] listeners attached');
})();

/* Hidden pages functionality */
document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const hiddenClass = 'hidden-page';
  const param = '-4398374983';
  const cookieName = 'derila_hidden_session';
  const cookieDays = 2;

  const urlHasSleepingSystem = window.location.pathname.includes('sleeping-system');
  const bodyIsHidden = body.classList.contains(hiddenClass);
  const urlHasParam = window.location.pathname.includes(param);

  const triggeredNow = bodyIsHidden || urlHasParam || urlHasSleepingSystem;

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  if (triggeredNow) {
    setCookie(cookieName, '1', cookieDays);
  }

  const hasActiveSession = triggeredNow || getCookie(cookieName) === '1';

  if (!hasActiveSession) return;

  const headerBtn = document.querySelector('.header__icons .btn');
  if (headerBtn) {
    headerBtn.setAttribute('href', '/collections/derila-all');
  }

  const announcementBarLink = document.querySelector('.announcement-bar__message a');
  if (announcementBarLink) {
    announcementBarLink.setAttribute('href', '/collections/derila-all');
  }

  const headerHeadingLink = document.querySelector('.header__heading-link');
  if (headerHeadingLink) {
    headerHeadingLink.setAttribute('href', '/pages/homepage');
  }

  function rewriteHref(href) {
    if (!href) return href;

    if (href === '/' || href.startsWith('/?') || href.startsWith('/#')) {
      return '/pages/homepage' + href.slice(1);
    }

    if (href.includes(param)) return href;

    const isRelative = href.startsWith('/products/') || href.startsWith('/collections/');
    const isAbsolute = /^https?:\/\/[^/]+\/(products|collections)\//.test(href);

    if (!isRelative && !isAbsolute) return href;

    const hashIndex = href.indexOf('#');
    const queryIndex = href.indexOf('?');

    let endIndex = href.length;
    if (hashIndex !== -1) endIndex = Math.min(endIndex, hashIndex);
    if (queryIndex !== -1) endIndex = Math.min(endIndex, queryIndex);

    const base = href.slice(0, endIndex);
    const rest = href.slice(endIndex);

    return base + param + rest;
  }

  function rewriteLink(link) {
    const href = link.getAttribute('href');
    const newHref = rewriteHref(href);
    if (newHref !== href) {
      link.setAttribute('href', newHref);
    }
  }

  function updateLinks(scope = document) {
    const links = scope.querySelectorAll(
      'a[href="/"], a[href^="/?"], a[href^="/#"], a[href*="/products/"], a[href*="/collections/"]'
    );
    links.forEach(rewriteLink);
  }

  updateLinks(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;

        if (node.matches?.('a[href="/"], a[href^="/?"], a[href^="/#"], a[href*="/products/"], a[href*="/collections/"]')) {
          rewriteLink(node);
        }

        if (node.querySelectorAll) {
          updateLinks(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* Kaching bundles price and quantity sync (except Bundle NC and Bundle C designs) */
(() => {
  const hasBundleV1orV2 = document.querySelector(
    '.product__info-container.kaching-design-bundle-nc, .product__info-container.kaching-design-bundle-c'
  );

  if (hasBundleV1orV2) return;

  const LABEL_WRAPPER = '.product-form__pack-label, .product-from__pack-label';
  const SINGLE_NAME = '.single-pack-name';
  const DOUBLE_NAME = '.double-pack-name';

  const PRICE_BOX = '.product__info-wrapper .product__price';
  const SALE = '.price-item--sale';
  const REGULAR = '.price-item--regular';
  const BADGE = '.price__badge-sale';

  const BAR = '.kaching-bundles__bar';
  const BAR_SELECTED = '.kaching-bundles__bar.kaching-bundles__bar--selected';
  const BAR_TITLE = '.kaching-bundles__bar-title';
  const BAR_PRICE = '.kaching-bundles__bar-price';
  const BAR_FULL = '.kaching-bundles__bar-full-price';

  const PRODUCT_FORM = 'product-form form, form[action*="/cart/add"]';
  const QUANTITY_INPUT = 'input[name="quantity"]';

  const norm = (t) => (t || '').replace(/\s+/g, ' ').trim();

  const hideEl = (el) => {
    if (!el) return;
    el.style.display = 'none';
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
  };

  const showEl = (el, display = '') => {
    if (!el) return;
    el.style.display = display;
    el.hidden = false;
    el.removeAttribute('aria-hidden');
  };

  const setText = (el, text) => {
    if (!el || !text) return;
    if (norm(el.textContent) === text) return;
    el.textContent = text;
  };

  const parseMoney = (text) => {
    const t = norm(text);
    if (!t) return null;

    const numMatch = t.match(/-?[\d.,]+/);
    if (!numMatch) return null;

    let numStr = numMatch[0];
    const lastDot = numStr.lastIndexOf('.');
    const lastComma = numStr.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    if (decPos >= 0) {
      const intPart = numStr.slice(0, decPos).replace(/[^\d-]/g, '');
      const decPart = numStr.slice(decPos + 1).replace(/[^\d]/g, '');
      numStr = `${intPart}.${decPart}`;
    } else {
      numStr = numStr.replace(/[^\d-]/g, '');
    }

    const value = Number(numStr);
    return Number.isFinite(value) ? value : null;
  };

  const getBars = () => Array.from(document.querySelectorAll(BAR));

  const getSelectedBar = () => {
    return (
      document.querySelector(BAR_SELECTED) ||
      document.querySelector(`${BAR} input[type="radio"]:checked`)?.closest(BAR) ||
      document.querySelector(BAR) ||
      null
    );
  };

  const getBarTitle = (bar) => norm(bar?.querySelector(BAR_TITLE)?.textContent);

  const getBarQuantity = (bar) => {
    if (!bar) return null;

    const title = getBarTitle(bar);
    const titleMatch = title.match(/^(\d+)\s*x\b/i) || title.match(/(\d+)/);
    if (titleMatch) {
      const qty = Number(titleMatch[1]);
      if (Number.isFinite(qty) && qty > 0) return qty;
    }

    const labelText = norm(bar.textContent);
    const fallbackMatch = labelText.match(/^(\d+)\s*x\b/i) || labelText.match(/(\d+)/);
    if (fallbackMatch) {
      const qty = Number(fallbackMatch[1]);
      if (Number.isFinite(qty) && qty > 0) return qty;
    }

    return null;
  };

  const updatePackLabels = (bar) => {
    const wrapper = document.querySelector(LABEL_WRAPPER);
    if (!wrapper) return;

    const singleEl = wrapper.querySelector(SINGLE_NAME);
    const doubleEl = wrapper.querySelector(DOUBLE_NAME);

    const bars = getBars();
    const firstTitle = getBarTitle(bars[0]);
    const secondTitle = getBarTitle(bars[1]);
    const selectedTitle = getBarTitle(bar);

    if (singleEl) {
      setText(singleEl, selectedTitle || firstTitle);
    }

    if (doubleEl) {
      setText(doubleEl, selectedTitle || secondTitle);
    }
  };

  const updatePriceFromBar = (bar) => {
    const priceBox = document.querySelector(PRICE_BOX);
    if (!priceBox || !bar) return;

    const saleEl = priceBox.querySelector(SALE);
    const regEl = priceBox.querySelector(REGULAR);
    const badgeEl = priceBox.querySelector(BADGE);

    const barSale = norm(bar.querySelector(BAR_PRICE)?.textContent);
    const barFull = norm(bar.querySelector(BAR_FULL)?.textContent);

    if (saleEl && barSale) {
      setText(saleEl, barSale);
      showEl(saleEl);
    }

    if (!barFull) {
      if (regEl) {
        regEl.textContent = '';
        hideEl(regEl);
      }
      if (badgeEl) {
        badgeEl.textContent = '';
        hideEl(badgeEl);
      }
      return;
    }

    if (regEl) {
      setText(regEl, barFull);
      showEl(regEl);
    }

    if (badgeEl) {
      const sale = parseMoney(barSale);
      const full = parseMoney(barFull);

      if (sale && full && full > sale) {
        const off = Math.round((1 - sale / full) * 100);
        setText(badgeEl, `${off}% OFF`);
        showEl(badgeEl);
      } else {
        badgeEl.textContent = '';
        hideEl(badgeEl);
      }
    }
  };

  const updateQuantityFromBar = (bar) => {
    const form =
      document.querySelector(PRODUCT_FORM) ||
      document.querySelector(QUANTITY_INPUT)?.closest('form');

    if (!form || !bar) return;

    const qtyInput = form.querySelector(QUANTITY_INPUT);
    if (!qtyInput) return;

    const qty = getBarQuantity(bar);
    if (!qty) return;

    if (String(qtyInput.value) !== String(qty)) {
      qtyInput.value = String(qty);
      qtyInput.setAttribute('value', String(qty));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const updateFromBar = (bar) => {
    if (!bar) return;
    updatePackLabels(bar);
    updatePriceFromBar(bar);
    updateQuantityFromBar(bar);
  };

  const bindEvents = () => {
    document.addEventListener(
      'change',
      (e) => {
        const input = e.target.closest(`${BAR} input[type="radio"]`);
        if (!input) return;

        const bar = input.closest(BAR);
        updateFromBar(bar);
      },
      true
    );

    document.addEventListener(
      'click',
      (e) => {
        const bar = e.target.closest(BAR);
        if (!bar) return;

        updateFromBar(bar);
      },
      true
    );

    document.addEventListener(
      'pointerdown',
      (e) => {
        const bar = e.target.closest(BAR);
        if (!bar) return;

        updateFromBar(bar);
      },
      true
    );
  };

  const init = () => {
    let tries = 0;
    const maxTries = 10;

    const tick = () => {
      const bars = getBars();
      const selectedBar = getSelectedBar();
      const priceBox = document.querySelector(PRICE_BOX);
      const form =
        document.querySelector(PRODUCT_FORM) ||
        document.querySelector(QUANTITY_INPUT)?.closest('form');

      if (bars.length && selectedBar && priceBox && form) {
        updateFromBar(selectedBar);
        bindEvents();
        return;
      }

      tries += 1;
      if (tries < maxTries) {
        requestAnimationFrame(tick);
      }
    };

    tick();
  };

  init();
})();

/* Kaching bundles rework for Bundle NC and Bundle C designs */
(() => {
  const hasBundleV1orV2 = !!document.querySelector(
    '.product__info-container.kaching-design-bundle-nc, .product__info-container.kaching-design-bundle-c'
  );

  if (!hasBundleV1orV2) return;

  const ROOT_SELECTOR = '.product-information .shopify-app-block, .shopify-section, body';

  const BAR_SELECTOR = '.kaching-bundles__bar';
  const PRICING_SELECTOR = '.kaching-bundles__bar-pricing';
  const PRICE_SELECTOR = '.kaching-bundles__bar-price';
  const COMPARE_SELECTOR = '.kaching-bundles__bar-full-price';
  const LABEL_SELECTOR = '.kaching-bundles__bar-label';
  const CONTENT_SELECTOR = '.kaching-bundles__bar-content';

  const OFF_BADGE_CLASS = 'bundle-off-badge';
  const SAVE_BADGE_CLASS = 'bundle-save-badge';
  const PER_PILLOW_CLASS = 'bundle-per-pillow';
  const COMPARE_WRAP_CLASS = 'compare-price';

  const parseMoney = (text) => {
    const t = (text || '').replace(/\s+/g, ' ').trim();
    if (!t) return null;

    const currencyMatch = t.match(/[$€£¥]|[A-Z]{3}/);
    const currencyToken = currencyMatch ? currencyMatch[0] : '';

    const numMatch = t.match(/-?[\d.,]+/);
    if (!numMatch) return null;

    let numStr = numMatch[0];
    const lastDot = numStr.lastIndexOf('.');
    const lastComma = numStr.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    if (decPos >= 0) {
      const intPart = numStr.slice(0, decPos).replace(/[^\d-]/g, '');
      const decPart = numStr.slice(decPos + 1).replace(/[^\d]/g, '');
      numStr = `${intPart}.${decPart}`;
    } else {
      numStr = numStr.replace(/[^\d-]/g, '');
    }

    const value = Number(numStr);
    if (!Number.isFinite(value)) return null;

    return { value, currencyToken };
  };

  const formatMoney = (value, currencyToken) => {
    if (!Number.isFinite(value)) return '';
    const token = (currencyToken || '').trim();
    const num = value.toFixed(2);
    return token ? `${token}${num}` : num;
  };

  const wrapCompareText = (compareEl) => {
    if (!compareEl) return;
    if (compareEl.querySelector(`.${COMPARE_WRAP_CLASS}`)) return;

    const textNodes = [...compareEl.childNodes].filter(
      (n) => n.nodeType === Node.TEXT_NODE && (n.textContent || '').trim()
    );
    if (!textNodes.length) return;

    const span = document.createElement('span');
    span.className = COMPARE_WRAP_CLASS;
    span.textContent = (textNodes[0].textContent || '').trim();

    compareEl.replaceChild(span, textNodes[0]);
  };

  const ensureOffBadge = (compareEl, offPct) => {
    let wrap = compareEl.querySelector('[data-bundle-off="1"]');
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.setAttribute('data-bundle-off', '1');
      wrap.className = OFF_BADGE_CLASS;
      wrap.style.marginLeft = '8px';
      wrap.style.whiteSpace = 'nowrap';

      const value = document.createElement('span');
      wrap.appendChild(value);

      wrap.appendChild(document.createTextNode(' OFF'));
      compareEl.appendChild(wrap);
    }

    const valueEl = wrap.querySelector('span');
    const sig = String(offPct);
    if (valueEl.dataset.sig !== sig) {
      valueEl.textContent = `${offPct}%`;
      valueEl.dataset.sig = sig;
    }
  };

  const ensurePerPillow = (content, text) => {
    let div = content.querySelector('[data-bundle-per-pillow="1"]');
    if (!div) {
      div = document.createElement('div');
      div.setAttribute('data-bundle-per-pillow', '1');
      div.className = PER_PILLOW_CLASS;
      content.appendChild(div);
    }

    if (div.dataset.sig !== text) {
      div.textContent = text;
      div.dataset.sig = text;
    }

    return div;
  };

  const ensureRadioInMainIfBundleV1 = (bar) => {
    const main = bar.querySelector('.kaching-bundles__bar-main');
    if (!main) return;

    if (main.querySelector(':scope > .kaching-bundles__bar-radio')) return;

    const radio = document.createElement('div');
    radio.className = 'kaching-bundles__bar-radio';

    main.insertBefore(radio, main.firstChild);
  };

  const ensureFirstLineOffBadgeIfBundleV1 = (bar) => {
    if (!document.querySelector('.product__info-container.kaching-design-bundle-nc')) return;

    const firstLine = bar.querySelector('.kaching-bundles__bar-first-line');
    const priceEl = bar.querySelector('.kaching-bundles__bar-price');
    const compareEl = bar.querySelector('.kaching-bundles__bar-full-price');

    if (!firstLine || !priceEl || !compareEl) return;

    const price = parseMoney(priceEl.textContent);
    const compare = parseMoney(compareEl.textContent);

    if (!price || !compare || compare.value <= price.value) {
      const existing = firstLine.querySelector('[data-bundle-off="1"]');
      if (existing) existing.remove();
      return;
    }

    const offPct = Math.round((1 - price.value / compare.value) * 100);

    let badge = firstLine.querySelector('[data-bundle-off="1"]');
    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('data-bundle-off', '1');
      badge.className = 'bundle-off-badge';

      const value = document.createElement('span');
      badge.appendChild(value);
      badge.appendChild(document.createTextNode(' OFF'));

      firstLine.appendChild(badge);
    }

    const valueEl = badge.querySelector('span');
    const sig = String(offPct);
    if (valueEl.dataset.sig !== sig) {
      valueEl.textContent = `${offPct}%`;
      valueEl.dataset.sig = sig;
    }
  };

  const ensureSaveDiv = (content, beforeNode, saveText) => {
    let div = content.querySelector('[data-bundle-save="1"]');
    if (!div) {
      div = document.createElement('div');
      div.setAttribute('data-bundle-save', '1');
      div.className = SAVE_BADGE_CLASS;
      div.style.whiteSpace = 'nowrap';

      const prefix = document.createElement('span');
      prefix.textContent = 'SAVE ';
      div.appendChild(prefix);

      const value = document.createElement('span');
      div.appendChild(value);

      if (beforeNode && content.contains(beforeNode)) {
        content.insertBefore(div, beforeNode);
      } else {
        content.appendChild(div);
      }
    } else {
      if (beforeNode && content.contains(beforeNode) && div.nextSibling !== beforeNode) {
        content.insertBefore(div, beforeNode);
      }
    }

    const valueEl = div.querySelector('span:last-child');
    if (valueEl.dataset.sig !== saveText) {
      valueEl.textContent = saveText;
      valueEl.dataset.sig = saveText;
    }
  };

  const removeSaveFromPricing = (pricing) => {
    const save = pricing.querySelector('[data-bundle-save="1"]');
    if (save) save.remove();
  };

  const updateBar = (bar) => {
    ensureRadioInMainIfBundleV1(bar);

    const pricing = bar.querySelector(PRICING_SELECTOR);
    const priceEl = bar.querySelector(PRICE_SELECTOR);
    const compareEl = bar.querySelector(COMPARE_SELECTOR);

    ensureFirstLineOffBadgeIfBundleV1(bar);

    const labelEl = bar.querySelector(LABEL_SELECTOR);
    const contentEl = bar.querySelector(CONTENT_SELECTOR);

    if (!pricing || !priceEl || !labelEl || !contentEl) return;

    wrapCompareText(compareEl);

    const price = parseMoney(priceEl.textContent);
    const compareTextEl = compareEl?.querySelector(`.${COMPARE_WRAP_CLASS}`);
    const compare = compareTextEl
      ? parseMoney(compareTextEl.textContent)
      : (compareEl ? parseMoney(compareEl.textContent) : null);

    if (compareEl && price && compare && compare.value > price.value) {
      const offPct = Math.round((1 - price.value / compare.value) * 100);
      ensureOffBadge(compareEl, offPct);
    } else {
      const offWrap = compareEl?.querySelector('[data-bundle-off="1"]');
      if (offWrap) offWrap.remove();
    }

    let perPillowDiv = null;
    const qty = Number(((labelEl.textContent || '').match(/\d+/) || [])[0]);
    if (price && Number.isFinite(qty) && qty > 0) {
      const per = price.value / qty;
      const token = price.currencyToken || compare?.currencyToken || '';
      perPillowDiv = ensurePerPillow(contentEl, `${formatMoney(per, token)} per pillow`);
    } else {
      const perDiv = contentEl.querySelector('[data-bundle-per-pillow="1"]');
      if (perDiv) perDiv.remove();
    }

    removeSaveFromPricing(pricing);

    if (price && compare && compare.value > price.value) {
      const save = compare.value - price.value;
      const token = compare.currencyToken || price.currencyToken;
      ensureSaveDiv(contentEl, perPillowDiv, formatMoney(save, token));
    } else {
      const saveDiv = contentEl.querySelector('[data-bundle-save="1"]');
      if (saveDiv) saveDiv.remove();
    }
  };

  const enforce = (root) => {
    root.querySelectorAll(BAR_SELECTOR).forEach(updateBar);
  };

  const attach = (root) => {
    let raf = 0;
    const run = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => enforce(root));
    };

    run();

    new MutationObserver(run).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  };

  const waitForRoots = () => {
    const roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) {
      requestAnimationFrame(waitForRoots);
      return;
    }
    roots.forEach(attach);
  };

  waitForRoots();
})();

(() => {
  const hasBundleV1orV2 = !!document.querySelector(
    '.product__info-container.kaching-design-bundle-nc, .product__info-container.kaching-design-bundle-c'
  );

  if (!hasBundleV1orV2) return;

  const normText = (t) => (t || '').replace(/\s+/g, ' ').trim();

  const parseMoney = (text) => {
    const t = normText(text);
    if (!t) return null;

    const currencyMatch = t.match(/[$€£¥]|[A-Z]{3}/);
    const currencyToken = currencyMatch ? currencyMatch[0] : '';

    const numMatch = t.match(/-?[\d.,]+/);
    if (!numMatch) return null;

    let numStr = numMatch[0];
    const lastDot = numStr.lastIndexOf('.');
    const lastComma = numStr.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    if (decPos >= 0) {
      const intPart = numStr.slice(0, decPos).replace(/[^\d-]/g, '');
      const decPart = numStr.slice(decPos + 1).replace(/[^\d]/g, '');
      numStr = `${intPart}.${decPart}`;
    } else {
      numStr = numStr.replace(/[^\d-]/g, '');
    }

    const value = Number(numStr);
    if (!Number.isFinite(value)) return null;

    return { value, currencyToken };
  };

  const getSelectedBar = () =>
    document.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected') ||
    document.querySelector('.kaching-bundles__bar');

  const syncFromSelectedBar = () => {
    const productPrice = document.querySelector('.product__price');
    if (!productPrice) return;

    const bar = getSelectedBar();
    if (!bar) return;

    const barPriceEl = bar.querySelector('.kaching-bundles__bar-price');
    const barCompareEl = bar.querySelector('.kaching-bundles__bar-full-price');
    if (!barPriceEl || !barCompareEl) return;

    const saleText = normText(barPriceEl.textContent);
    const regularText = normText(barCompareEl.textContent);

    const sig = `${saleText}||${regularText}`;
    if (productPrice.dataset.kachingSig === sig) return;
    productPrice.dataset.kachingSig = sig;

    const saleEl = productPrice.querySelector('.price-item--sale');
    const regularEl = productPrice.querySelector('.price-item--regular');

    if (saleEl && saleEl.textContent !== saleText) saleEl.textContent = saleText;

    if (regularEl) {
      if (regularEl.textContent !== regularText) regularEl.textContent = regularText;
      if (regularEl.getAttribute('style')) regularEl.removeAttribute('style');
    }

    const price = parseMoney(saleText);
    const compare = parseMoney(regularText);

    let badge = Array.from(productPrice.children).find(
      (el) => el && el.nodeType === 1 && el.matches('[data-bundle-off="1"]')
    );

    if (price && compare && compare.value > price.value) {
      const offPct = Math.round((1 - price.value / compare.value) * 100);
      const badgeSig = String(offPct);

      if (!badge) {
        badge = document.createElement('span');
        badge.setAttribute('data-bundle-off', '1');
        badge.className = 'bundle-off-badge';
        badge.innerHTML = `<span data-sig="${badgeSig}">${offPct}%</span> OFF`;
        productPrice.appendChild(badge);
      } else {
        if (badge.parentElement !== productPrice || badge !== productPrice.lastElementChild) {
          productPrice.appendChild(badge);
        }
        const valueEl = badge.querySelector('span');
        if (!valueEl || valueEl.dataset.sig !== badgeSig) {
          badge.innerHTML = `<span data-sig="${badgeSig}">${offPct}%</span> OFF`;
        }
      }
    } else {
      if (badge) badge.remove();
    }
  };

  const makeRafRunner = (fn) => {
    let raf = 0;
    return () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        fn();
      });
    };
  };

  const run = makeRafRunner(syncFromSelectedBar);

  const observeBars = () => {
    const anyBar = document.querySelector('.kaching-bundles__bar');
    if (!anyBar) return false;

    const container =
      anyBar.closest('.kaching-bundles') ||
      anyBar.parentElement ||
      document.body;

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes') {
          if (m.target && m.target.classList && m.target.classList.contains('kaching-bundles__bar')) {
            run();
            return;
          }
        }
        if (m.type === 'characterData') {
          run();
          return;
        }
        if (m.type === 'childList') {
          run();
          return;
        }
      }
    });

    mo.observe(container, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    run();
    return true;
  };

  const wait = () => {
    if (!observeBars()) requestAnimationFrame(wait);
  };

  wait();
})();

/* Clone main add to cart buttons (new ergo template) */
document.addEventListener('click', function (e) {
  const cloneBtn = e.target.closest('.clone-add-to-cart');
  if (!cloneBtn) return;

  e.preventDefault();

  const productFormComponent = document.querySelector('product-form.product-form');
  if (!productFormComponent) return;

  const form = productFormComponent.querySelector('form[action="/cart/add"][data-type="add-to-cart-form"]');
  if (!form) return;

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit(form.querySelector('button[type="submit"][name="add"]') || undefined);
    return;
  }

  const submitBtn = form.querySelector('button[type="submit"][name="add"]');
  if (submitBtn) submitBtn.click();
});

/* Advertorial structure rework */
document.addEventListener('DOMContentLoaded', function () {

  function moveProductInfo() {
    const advertorial = document.querySelector('.template-advertorial');
    const productInfo = advertorial?.querySelector('product-info');
    const marker = advertorial?.querySelector('.insert-product-info');

    if (!advertorial || !productInfo || !marker) return;

    const wrapper = marker.closest('.page-width.page-width--narrow');
    if (!wrapper) return;

    const newWrapper = wrapper.cloneNode(false);

    while (marker.nextSibling) {
      newWrapper.appendChild(marker.nextSibling);
    }

    wrapper.parentNode.insertBefore(productInfo, wrapper.nextSibling);
    wrapper.parentNode.insertBefore(newWrapper, productInfo.nextSibling);

    marker.remove();
  }

  moveProductInfo();
});

/* Change ATC button text in advertorial */
document.addEventListener("DOMContentLoaded", function () {
  const advertorialTemplate = document.querySelector(".template-advertorial");
  if (!advertorialTemplate) return;

  const buttonText = advertorialTemplate.querySelector(".product-form__submit > span");
  if (buttonText) {
    buttonText.textContent = "If You Snooze, You Lose—Order yours today!";
  }
});

/* 10 minute timer in product description */
document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".product__description");

  if (!description) return;

  if (description.innerHTML.includes("{timer}")) {
    description.innerHTML = description.innerHTML.replace(
      "{timer}",
      '<span id="countdown-timer">10:00</span>'
    );

    let time = 900;
    const timerEl = document.getElementById("countdown-timer");

    const interval = setInterval(() => {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;

      timerEl.textContent =
        String(minutes).padStart(2, "0") +
        ":" +
        String(seconds).padStart(2, "0");

      if (time <= 0) {
        clearInterval(interval);
      }

      time--;
    }, 1000);
  }
});

/* Add domain to terms pages */
document.addEventListener('DOMContentLoaded', function () {
  const shopDomain = window.location.origin;

  const containers = [
    document.querySelector('.main-page-content'),
    document.querySelector('.shopify-policy__container')
  ].filter(Boolean);

  if (!containers.length) return;

  const replaceContent = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('{domain}') || node.nodeValue.includes('derilashop.co.uk')) {
        node.nodeValue = node.nodeValue
          .replaceAll('{domain}', shopDomain)
          .replaceAll('https://derilashop.co.uk', shopDomain);
      }
    }

    root.querySelectorAll('*').forEach(el => {
      [...el.attributes].forEach(attr => {
        if (attr.value.includes('{domain}') || attr.value.includes('derilashop.co.uk')) {
          el.setAttribute(
            attr.name,
            attr.value
              .replaceAll('{domain}', shopDomain)
              .replaceAll('https://derilashop.co.uk', shopDomain)
          );
        }
      });
    });
  };

  containers.forEach(container => replaceContent(container));

  containers.forEach(container => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            replaceContent(node);
          }
        });
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  });
});

/* Change kaching images for Xth discount design */
(() => {
  const WRAPPER_SELECTOR = '.kaching-design-x-th-discount';
  const MOBILE_QUERY = '(max-width: 749px)';

  const TARGETS = [
    {
      selector: '.kaching-bundles__bar:nth-child(2) .kaching-bundles__bar-image',
      src: 'https://cdn.shopify.com/s/files/1/0897/9129/9927/files/ergo-2-mobile.png?v=1778136565'
    },
    {
      selector: '.kaching-bundles__bar:first-child .kaching-bundles__bar-image',
      src: 'https://cdn.shopify.com/s/files/1/0897/9129/9927/files/ergo-4-mobile.png?v=1778136565'
    }
  ];

  const media = window.matchMedia(MOBILE_QUERY);

  const updateImage = (el, src) => {
    if (!el) return;

    const img = el.matches('img') ? el : el.querySelector('img');

    if (img) {
      if (img.src !== src) img.src = src;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      return;
    }

    el.style.backgroundImage = `url("${src}")`;
  };

  const updateImages = (root) => {
    if (!media.matches) return;

    TARGETS.forEach(({ selector, src }) => {
      updateImage(root.querySelector(selector), src);
    });
  };

  const attach = (root) => {
    let raf = 0;

    const run = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => updateImages(root));
    };

    run();

    const observer = new MutationObserver(run);

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes', 'style', 'class']
    });

    if (media.addEventListener) {
      media.addEventListener('change', run);
    } else {
      media.addListener(run);
    }
  };

  const waitForWrapper = () => {
    const root = document.querySelector(WRAPPER_SELECTOR);

    if (!root) {
      requestAnimationFrame(waitForWrapper);
      return;
    }

    attach(root);
  };

  waitForWrapper();
})();

/* Hide badges in cart if products are added from a specific url */
(function () {
  var CONFIG = {
    targetPath: '/products/derila-ergo-neck-support-pillow-543122',
    cookieName: 'cart_hide_badge',
    cookieDays: 1,
    bodyClass: 'cart-hide-badge'
  }

  function isTargetUrl() {
    return window.location.pathname.indexOf(CONFIG.targetPath) === 0
  }

  function setCookie() {
    var expires = new Date(Date.now() + CONFIG.cookieDays * 864e5).toUTCString()
    document.cookie = CONFIG.cookieName + '=1; expires=' + expires + '; path=/'
  }

  function hasCookie() {
    return document.cookie.indexOf(CONFIG.cookieName + '=1') !== -1
  }

  if (hasCookie()) {
    document.body.classList.add(CONFIG.bodyClass)
  }

  var nativeFetch = window.fetch
  window.fetch = function () {
    var args = arguments
    var url = args[0] instanceof Request ? args[0].url : args[0]
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && isTargetUrl()) {
      setCookie()
      document.body.classList.add(CONFIG.bodyClass)
    }
    return nativeFetch.apply(this, args)
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]')
    if (form && isTargetUrl()) {
      setCookie()
      document.body.classList.add(CONFIG.bodyClass)
    }
  })
})()

/* Bundle builder */
function bundleBuilderInit() {
    document.querySelectorAll('[data-bundle-builder]').forEach(function (root) {
        if (root.dataset.bundleBound) return;
        root.dataset.bundleBound = 'true';

        var tiers = JSON.parse(root.dataset.tiers).sort(function (a, b) { return a.min - b.min; });
        var ctaText = root.dataset.ctaText || 'Add to Cart';
        var maxMessage = root.dataset.maxMessage || '🔥 Maximum savings unlocked — 72% OFF';
        var items = Array.from(root.querySelectorAll('[data-bundle-item]'));

        var tierEls = Array.from(root.querySelectorAll('[data-tier]'));
        var segmentEls = Array.from(root.querySelectorAll('[data-segment]'));
        var bannerEl = root.querySelector('[data-bundle-banner]');
        var messageEl = root.querySelector('[data-bundle-message]');
        var countEl = root.querySelector('[data-selected-count]');
        var priceEl = root.querySelector('[data-total-price]');
        var compareEl = root.querySelector('[data-total-compare]');
        var submitBtn = root.querySelector('[data-bundle-submit]');
        var submitTextEl = root.querySelector('[data-submit-text]');

        function getTier(count) {
            var current = tiers[0];
            tiers.forEach(function (tier) {
                if (count >= tier.min) current = tier;
            });
            return current;
        }

        function getNextTier(count) {
            for (var i = 0; i < tiers.length; i++) {
                if (tiers[i].min > count) return tiers[i];
            }
            return null;
        }

        function update() {
            var count = 0;
            var subtotal = 0;
            var discounted = 0;

            items.forEach(function (item) {
                var qty = parseInt(item.dataset.qty, 10) || 0;
                var price = parseInt(item.dataset.price, 10) || 0;
                count += qty;
                subtotal += price * qty;
            });

            var tier = getTier(count);
            var next = getNextTier(count);
            var percent = (count > 0 && tier) ? tier.percent : 0;

            items.forEach(function (item) {
                var qty = parseInt(item.dataset.qty, 10) || 0;
                if (qty <= 0) return;
                var unitPrice = parseInt(item.dataset.price, 10) || 0;
                var unitDiscounted = percent > 0 ? Math.round(unitPrice * (1 - percent / 100)) : unitPrice;
                discounted += unitDiscounted * qty;
            });

            if (countEl) countEl.textContent = count;
            if (priceEl) priceEl.textContent = getMoney(discounted / 100);
            if (compareEl) {
                if (percent > 0) {
                    compareEl.textContent = getMoney(subtotal / 100);
                    compareEl.hidden = false;
                } else {
                    compareEl.hidden = true;
                }
            }
            if (submitTextEl) {
                submitTextEl.textContent = percent > 0 ? (ctaText + ' - Save ' + percent + '%') : ctaText;
            }
            if (submitBtn) submitBtn.disabled = count === 0;

            if (bannerEl && messageEl) {
                if (next) {
                    var remaining = next.min - count;
                    var word = remaining === 1 ? 'item' : 'items';
                    messageEl.textContent = 'Add ' + remaining + ' more ' + word + ' to unlock ' + next.percent + '% off';
                    bannerEl.hidden = false;
                    bannerEl.classList.remove('is-max');
                } else if (count > 0) {
                    messageEl.textContent = maxMessage;
                    bannerEl.hidden = false;
                    bannerEl.classList.add('is-max');
                } else {
                    bannerEl.hidden = true;
                    bannerEl.classList.remove('is-max');
                }
            }

            tierEls.forEach(function (el) {
                var min = parseInt(el.dataset.tierMin, 10);
                el.classList.toggle('is-active', tier && tier.min === min);
                el.classList.toggle('is-reached', count >= min);
            });

            segmentEls.forEach(function (el) {
                var min = parseInt(el.dataset.tierMin, 10);
                el.classList.toggle('is-reached', count >= min);
            });
        }

        function setQty(item, qty) {
            var min = parseInt(item.dataset.min, 10) || 0;
            qty = Math.max(min, qty);
            item.dataset.qty = qty;

            var valueEl = item.querySelector('[data-qty-value]');
            if (valueEl) valueEl.textContent = qty;

            item.classList.toggle('is-selected', qty > 0);

            var control = item.querySelector('[data-control]');
            if (control) control.classList.toggle('is-stepper', qty > 0);

            update();
        }

        items.forEach(function (item) {
            var addBtn = item.querySelector('[data-add-btn]');
            var minusBtn = item.querySelector('[data-qty-minus]');
            var plusBtn = item.querySelector('[data-qty-plus]');

            if (addBtn) {
                addBtn.addEventListener('click', function () {
                    setQty(item, 1);
                });
            }
            if (minusBtn) {
                minusBtn.addEventListener('click', function () {
                    setQty(item, (parseInt(item.dataset.qty, 10) || 0) - 1);
                });
            }
            if (plusBtn) {
                plusBtn.addEventListener('click', function () {
                    setQty(item, (parseInt(item.dataset.qty, 10) || 0) + 1);
                });
            }
        });

        if (submitBtn) {
            submitBtn.addEventListener('click', function () {
                var lineItems = items
                    .filter(function (item) { return (parseInt(item.dataset.qty, 10) || 0) > 0; })
                    .map(function (item) {
                        return { id: item.dataset.variantId, quantity: parseInt(item.dataset.qty, 10) };
                    });

                if (!lineItems.length) return;

                submitBtn.disabled = true;
                submitBtn.classList.add('is-loading');

                var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: lineItems,
                        sections: cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [],
                        sections_url: window.location.pathname
                    })
                })
                    .then(function (res) { return res.json(); })
                    .then(function (result) {
                        if (result.status) {
                            console.error(result);
                            return;
                        }
                        if (cart) {
                            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                            setTimeout(function () { cart.renderContents(result); }, 100);
                        }
                    })
                    .catch(function (err) { console.error(err); })
                    .finally(function () {
                        submitBtn.disabled = false;
                        submitBtn.classList.remove('is-loading');
                        update();
                    });
            });
        }

        update();
    });
}

function removeGrouptifyBadge() {
    function removeBadge(root) {
        var badge = root.querySelector('div[title="Powered by Grouptify"]');
        if (badge) badge.remove();
    }

    var container = document.querySelector('.product__info-container');
    if (!container) return;

    removeBadge(container);

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.matches && node.matches('div[title="Powered by Grouptify"]')) {
                    node.remove();
                } else if (node.querySelector) {
                    removeBadge(node);
                }
            });
        });
    });

    observer.observe(container, { childList: true });
}

/* Derila BF gift card */
document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('.derila-bf-gift__option input')) return;

    var form = input.closest('form');
    var label = form && form.querySelector('.derila-bf-gift__button-text');
    if (!label) return;

    var template = form.getAttribute('data-label-template') || 'Buy a [amount] gift card';
    label.textContent = template.replace('[amount]', input.getAttribute('data-amount'));
});